import { render, staticRenderFns } from "./goodsOrder.vue?vue&type=template&id=c443969a&scoped=true&"
import script from "./goodsOrder.vue?vue&type=script&lang=js&"
export * from "./goodsOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c443969a",
  null
  
)

export default component.exports